import React, { FC, useState } from 'react';
import { Form as FormikForm, Formik, FormikHelpers } from 'formik';
import { MutationFunction } from 'react-apollo';

import {
  CreateUserSegmentComponent,
  CreateUserSegmentInput,
  GetUserSegmentsDocument,
  SegmentStatus,
} from 'api';
import { createUserSegmentResponse } from 'apollo/responses';
import { createUserSegment } from 'apollo/reducers';
import { SegmentSchema } from 'features/admin/validations';
import { useNotify } from 'hooks';

import Title from './Title';

type HandleCreate = [
  MutationFunction,
  CreateUserSegmentInput,
  FormikHelpers<CreateUserSegmentInput>,
];

const EMPTY_SEGMENT: CreateUserSegmentInput = {
  title: '',
  segment_status: SegmentStatus.Disabled,
};

const SegmentCreate: FC = () => {
  const [working, setWorking] = useState(false);
  const notify = useNotify();

  function createNotify() {
    notify.info({ i18n: { i18nKey: 'common:saved' } });
    setWorking(false);
  }

  function handleCreate(...args: HandleCreate) {
    const [mutation, values, formikActions] = args;

    mutation({
      variables: { data: values },
      update: (cache, result) => {
        createUserSegment({
          cache,
          result,
          query: GetUserSegmentsDocument,
          variables: {},
        });
      },
      optimisticResponse: createUserSegmentResponse(values),
    });

    formikActions.resetForm();
    setWorking(true);
  }

  return (
    <CreateUserSegmentComponent onError={notify.mutationError} onCompleted={createNotify}>
      {mutation => (
        <Formik
          initialValues={EMPTY_SEGMENT}
          onSubmit={(values, formikActions) => handleCreate(mutation, values, formikActions)}
          validationSchema={SegmentSchema}
          render={() => (
            <FormikForm>
              <Title working={working} activeIcon={false} mode="create" />
            </FormikForm>
          )}
        />
      )}
    </CreateUserSegmentComponent>
  );
};

export default SegmentCreate;
